<template>
    <div>
        <div class="modal-button">
             <el-button
                type="primary"
                size="mini"
                style="width: 92px"
                @click="dialogTableVisible = true"
                >
                Добавить
                </el-button>
        </div>
        <el-dialog title="Создание новой темы" :visible.sync="dialogTableVisible">
            <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="165px">
                <el-form-item label="Наименование темы" prop="name">
                    <el-input size="small" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                    <el-input size="small" v-model="form.email"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                    <el-button
                        size="mini"
                        @click="dialogTableVisible = false"
                        >
                        Отменить
                    </el-button>

                    <el-button
                        size="mini"
                        type="primary"
                        @click="submit()"
                        :loading="loading"
                        >
                        Добавить
                    </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Поле не должно быть пустым'));
            } else if(value !== '') {
                let test = value.split(';');

                test = test.map(item => item.trim())

                let emailRegexp = /^[-._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/

                let valid = false

                for(let i = 0; i<test.length; i++) {
                    if(!emailRegexp.test(test[i])) {
                        callback(new Error('Некорректно указана почта'));
                        valid = false
                        break;

                    } else {
                        valid = true
                    }
                }
                if(valid) callback();
            } else {
    
            }
        };

export default {
    
    data() {
        return {
            loading: false,
            dialogTableVisible: false,
            form: {
                name: '',
                email: '',
            },
            rules: {
				name: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    {
						min: 3,
						max: 50,
						message: "Максимум 50 символов",
						trigger: "blur"
					}
				],
				email: [
					{ validator: validatePass2, },
				],
            }
        }
    },
    props: {

    },
    methods: {
        async submit() {
            this.$refs.form.validate(async (valid) => {
                console.log('valid', valid)
                if(valid) {
                    this.loading = true
                    try {
                        await this.$store.dispatch('userRequestCreate', this.form)
                        this.$refs.form.resetFields()
                        this.dialogTableVisible = false
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }
                    this.loading = false
                } else {
                    return false;
                }
            })


        }
    }
}
</script>
